<template>
  <VApp id="inspire">
    <VContent>
      <VContainer
        fluid
        fill-height
      >
        <VLayout
          align-center
          justify-center
        >
          <VFlex
            xs12
            md6
            lg4
          >
            <VCard class="elevation-12">
              <VToolbar
                dark
                color="primary"
              >
                <VTooltip bottom>
                  <VBtn
                    slot="activator"
                    icon
                    large
                    href="/"
                  >
                    <VIcon large>
                      home
                    </VIcon>
                  </VBtn>
                  <span>{{ $nt('home') }}</span>
                </VTooltip>
                <VToolbarTitle>{{ heading }}</VToolbarTitle>
                <VSpacer />

                <VMenu>
                  <VBtn
                    slot="activator"
                    flat
                    icon
                  >
                    {{ this.$i18n.locale }}
                  </VBtn>
                  <VList>
                    <VListTile
                      v-for="language in languagesList"
                      :key="language.id"
                      @click="changeLocale(language.name)"
                    >
                      <VListTileTitle>{{ languageNames[language.name] }}</VListTileTitle>
                    </VListTile>
                  </VList>
                </VMenu>
              </VToolbar>
              <VCardText>
                <slot />
              </VCardText>
              <VCardActions>
                <slot name="navigation" />
                <VSpacer />
                <slot name="action" />
              </VCardActions>
            </VCard>
          </VFlex>
          <GlobalNotifications />
        </VLayout>
      </VContainer>
    </VContent>
  </VApp>
</template>

<script>
import GlobalNotifications from '@/components/layouts/parts/GlobalNotifications'
import setLayoutClass from '@/utils/setLayoutClass'
import '@/styles/webapp/app.scss'
import { loadLanguageAsync } from '../../locales/i18n-setup'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AuthLayout',
  components: { GlobalNotifications },
  props: ['heading'],
  data () {
    return {
      languageNames: {
        en: 'English',
        ru: 'Русский',
        de: 'Deutsch'
      }
    }
  },
  computed: {
    ...mapGetters('languages', ['languagesList'])
  },
  methods: {
    async changeLocale (locale) {
      try {
        localStorage.locale = locale
        await loadLanguageAsync(locale)
        this.$moment.locale(locale)
      } catch (e) {
        this.$notification({
          errors: {
            message: [this.$nt('errorWhileLoadingTranslations')]
          }
        })
      }
    }
  },
  mounted () {
    setLayoutClass('layout-webapp')
    this.changeLocale(typeof localStorage.locale === 'undefined' ? 'de' : localStorage.locale)
  }
}
</script>

<style scoped>

</style>
